<template>
  <div class="approve-whole-page">
    <div class="scroll-wrap">
      <div class="success-wrap fail-wrap">
        <div class="content-wrap">
          <div class="img-smile">
            <img src="~@/assets/noAccess.png">
          </div>
          <div class="success-text">
            <span class="iconfont icon-gou icon-gou2">&#xe652;</span>
            <span class="operation operation2">Access failed!</span>
          </div>
          <div class="send-reason">{{ text }}</div>
          <div class="go-btn-wrap">
            <div class="btn" @click="goHome">
              <span>Go Homepage</span>
              <span class="iconfont icon-right">&#xe687;</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NoAccess',
  data() {
    return {
      text:'Sorry, you do not have access to this page. If you would like to obtain access, please contact the eShop system administrator.'
    }
  },
  methods: {
    goHome() {
      this.$router.push({ path: '/catalogue' })
    }
  },
  mounted() {
    
  }
}
</script>

<style lang="less" scoped>
/* 与 HasSendEmail 等页面保持一致：public.less 在 public/css 下，@ 指向 src，故用相对路径 */
@import url('../../../public/css/public.less');
@import url('./index.less');
</style>
